export const headApi = `https://api.bangles.org.in/api/rest`;

// export const localApi = `http://localhost:8085/api`;
export const localApi = `https://api.inshabangles.com/api`;

// export const localApi = `https://bangles.org.in:8443/api`;